const addToString = (to, str) => Object.defineProperty(to, 'toString', {
  value: () => str,
  enumerable: false,
  configurable: false
});

export const Include = (ids, weDontCareAboutLoaded) => {
  return ids.slice();
};

addToString(Include, '+');

export const Exclude = (ids, all) => {
  return all
    ? all
      .map(({ id }) => id)
      .filter((set => id => !set.has(id))(new Set(ids)))
    : [];
};

addToString(Exclude, '-');

const modes = {

  // Brakets are required to call toString other than Symbol.toString
  [Include]: Include,
  [Exclude]: Exclude
};

/**
 * Enum-like valueOf function that "deserializes" strings to functions.
 */
const valueOf = mode => modes[mode];

export default valueOf;

export const toggle = (id, ids) => ids.indexOf(id) === -1
  ? ids.concat(id)
  : ids.filter(item => item !== id);



// WEBPACK FOOTER //
// ./src/utils/SelectionModes.js